export default __webpack_public_path__ + "static/media/Frame 107.fabf5373.png";